import React, { useState } from 'react';
import Modal from '../Modal';
import Link from '../Link';

const LinkToModal = ({ linkText, children, modalName = 'modal' }) => {
  const [showModal, setShowModal] = useState(false);
  const toggleShowModal = () => setShowModal(!showModal);
  const linkURL = '' || `?modalName=${modalName}`;

  return (
    <>
      <Modal statusModal={showModal} onClose={toggleShowModal}>
        {children}
      </Modal>
      <Link href={linkURL} icon="info" onClick={toggleShowModal}>
        {linkText}
      </Link>
    </>
  );
};
export default LinkToModal;
